export enum InformationCenterMessageType {
    Info = 'Information',
    Warning = 'Warning',
    Alert = 'Alert',
}
